import { useState } from 'react';
import { isEmpty } from '@hll/eapp-utils';
import request from 'umi-request';

type AreaType = {
  area_code: string;
  area_name: string;
  area_parent_id: number;
  id: number;
};

/**
 * 获取省市区json - 配置列表：https://cool-v.huolala.work/gallery/296 area.json
 * 由于数据比较大，放到cdn存储
 * 目前仅在发票-地址编辑-省市区选择器用到
 */
type ProvinceCityAreaType = { areaList?: AreaType[] };
export default function ProvinceCityArea() {
  const [areaList, setAreaList] = useState<ProvinceCityAreaType>(); // 全部城市列表

  const [provinceCityAreaLoading, setProvinceCityAreaLoading] = useState(false);

  const getProvinceCityAreConfig = () => {
    if (provinceCityAreaLoading) {
      return;
    }
    setProvinceCityAreaLoading(true);
    request(
      'https://static.huolala.cn/image/76c2577a2735df4f70b13df09ff1628e7ce6e3aa.json'
    ).then((res: AreaType[]) => {
      if (res?.length) {
        setAreaList({ areaList: res });
      }
    });
  };

  const provinceCityAreaConfig = new Proxy(
    { ...areaList },
    {
      get(obj: ProvinceCityAreaType, prop: string, receiver) {
        const res = Reflect.get(obj, prop, receiver);
        if (isEmpty(res)) {
          getProvinceCityAreConfig();
        } else {
          setProvinceCityAreaLoading(false);
        }
        return res;
      },
    }
  );
  return {
    /** 获取城市列表 loading */
    provinceCityAreaLoading,

    /** 城市数据 */
    provinceCityAreaConfig,
  };
}
